import { Link } from "react-router-dom";
import { dramas, dramaCategories } from "@/mocks/dramas";

const hot = [...dramas].sort((a, b) => b.rating - a.rating).slice(0, 5);

export default function SidebarHot() {
  return (
    <div className="flex flex-col gap-4">
      <section className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-fire-line text-accent-600"></i>
          热门推荐榜
        </h2>
        <ol className="mt-3 flex flex-col gap-2">
          {hot.map((drama, i) => (
            <li key={drama.id}>
              <Link to={`/detail/${drama.id}`} className="group flex cursor-pointer items-center gap-3">
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-semibold ${
                    i < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                  {drama.title}
                </span>
                <span className="flex items-center gap-1 text-xs text-accent-700">
                  <i className="ri-star-fill"></i>
                  {drama.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-price-tag-3-line text-primary-500"></i>
          热门标签
        </h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {dramaCategories.map((category) => (
            <Link
              key={category.key}
              to={`/category?type=${encodeURIComponent(category.key)}`}
              className="cursor-pointer rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-500 hover:text-background-50"
            >
              {category.key}
            </Link>
          ))}
        </div>
      </section>

      <section className="overflow-hidden rounded-lg border border-primary-200 bg-primary-50 p-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-primary-800">
          <i className="ri-compass-3-line"></i>
          快捷入口
        </h2>
        <div className="mt-3 flex flex-col gap-2">
          <Link
            to="/category?status=更新中"
            className="flex cursor-pointer items-center justify-between rounded-md bg-background-50 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:text-primary-600"
          >
            <span className="flex items-center gap-2">
              <i className="ri-tv-2-line text-primary-500"></i>
              正在更新
            </span>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          </Link>
          <Link
            to="/special"
            className="flex cursor-pointer items-center justify-between rounded-md bg-background-50 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:text-primary-600"
          >
            <span className="flex items-center gap-2">
              <i className="ri-bookmark-3-line text-primary-500"></i>
              主题专题
            </span>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          </Link>
          <Link
            to="/about"
            className="flex cursor-pointer items-center justify-between rounded-md bg-background-50 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:text-primary-600"
          >
            <span className="flex items-center gap-2">
              <i className="ri-information-line text-primary-500"></i>
              关于本站
            </span>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          </Link>
        </div>
      </section>
    </div>
  );
}